import { Button, Helper, Icon, STATUS_COLOR, Tooltip } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tags } from '@hero/atoms';
import * as S from '@hero/components/molecules/GiftMessage/GiftMessageInputs/style';
import { MessageLibraryModal } from '@hero/molecules';
import { useNotification } from '@hero/store/hooks';

import { ReviewMessageBadge } from './CustomizeMessageModal/ReviewMessageBadge';

function GiftMessageFooter({
  tagActive,
  setOccasion,
  editorStatus,
  handlePaste,
  charCount,
  limit,
  error,
  editorPlainText,
  customizeActive,
  customMessageLength,
  isOpenCustomizeMessageModal,
  setOpenCustomizeMessageModal,
  showReviewMessageBadge = true,
  renderCustomizeMessageModal,
  isIconTitlesHide = false,
  charComponent
}) {
  const { t } = useTranslation();
  const [showMessageLibrary, setShowMessageLibrary] = React.useState(false);
  const { showError } = useNotification();

  const tags = [
    {
      name: t('recipientSName', { name: t('firstName').toLocaleLowerCase() }),
      placeholder: '{{firstName}}'
    },
    {
      name: t('recipientSName', { name: t('lastName').toLocaleLowerCase() }),
      placeholder: '{{lastName}}'
    },
    {
      name: t('recipientSName', {
        name: `${t('first').toLocaleLowerCase()} & ${t('lastName').toLocaleLowerCase()}`
      }),
      placeholder: '{{firstName}} {{lastName}}'
    }
  ];

  return (
    <>
      <S.TextEditorFooter>
        {charComponent ?? (
          <Helper error={error} text={t('lengthCharacters', { length: charCount, limit })} />
        )}
        <S.TextEditorFooterRight>
          {tagActive ? (
            <Tooltip
              content={t('personalizeExperienceTooltipText')}
              size="lg"
              tooltipConfig={{ placement: 'top' }}
            >
              <Tags tags={tags} hideTagsTitle={isIconTitlesHide} handlePaste={handlePaste} />
            </Tooltip>
          ) : null}
          {customizeActive ? (
            <>
              {renderCustomizeMessageModal &&
                renderCustomizeMessageModal({
                  isOpenCustomizeMessageModal,
                  setOpenCustomizeMessageModal
                })}
              <Tooltip
                content={t('customizeExperienceTooltipText')}
                size="lg"
                tooltipConfig={{ placement: 'top' }}
              >
                <Button
                  color="secondary"
                  variant="link"
                  disabled={editorPlainText.length < 3}
                  onClick={() => setOpenCustomizeMessageModal(true)}
                  style={{ fontSize: 12 }}
                >
                  <Icon name="contacts" />
                  {!isIconTitlesHide && t('customize')}
                </Button>
              </Tooltip>
            </>
          ) : null}
          <Tooltip
            content={t('giftBasedLibraryInfoTooltipText')}
            size="lg"
            tooltipConfig={{ placement: 'top' }}
          >
            <Button
              color="secondary"
              variant="link"
              onClick={() => {
                setShowMessageLibrary(true);
              }}
              style={{ fontSize: 12 }}
            >
              <Icon name="library" />
              {!isIconTitlesHide && t('library')}
            </Button>
          </Tooltip>
        </S.TextEditorFooterRight>
      </S.TextEditorFooter>
      {!charComponent && limit < charCount && (
        <Helper
          error={editorStatus === STATUS_COLOR.error}
          text={t('characterLimitWarning', { limit })}
        />
      )}
      {showMessageLibrary && (
        <MessageLibraryModal
          isOpen={showMessageLibrary}
          onClose={() => setShowMessageLibrary(false)}
          onClick={({ message, occasion }) => {
            if (charCount + message.length > limit) {
              showError({
                type: 'toast',
                message: t('characterLimitWarning', { limit })
              });
              return;
            }
            handlePaste({ text: message });
            setOccasion && setOccasion({ occasion, message });
          }}
        />
      )}
      {customMessageLength > 0 && customizeActive && showReviewMessageBadge && (
        <ReviewMessageBadge
          customMessageLength={customMessageLength}
          setOpenCustomizeMessageModal={setOpenCustomizeMessageModal}
        />
      )}
    </>
  );
}
export { GiftMessageFooter };
